import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGardeningWateringPipe = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "gardening-watering-pipe" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M14.25,16H9.75a3,3,0,0,1,0-6H16.5a6,6,0,0,1,0,12H9.75a9,9,0,0,1,0-18"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M17.25,6.25H12a2.25,2.25,0,0,1,0-4.5h5.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M17.25,2.5l5.256.657a.85.85,0,0,1,0,1.686L17.25,5.5"
		})
	]
});
export default SvgGardeningWateringPipe;
